<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { Section } from '@agapi/ui/section';
  import { Image } from '@agapi/ui/image';

  import RichText from '../rich-text/rich-text.svelte';
  import { imageContentStyles } from './image-content.styles';
  import type { HeroProps } from './image-content.types';

  const {
    imagePosition = 'none',
    image,
    title,
    description,
    overlay = false,
    contentAlign = 'center',
    colorVariant = 'default',
    css: cssProp,
    headingType = 'h2',
    use,
    children,
  }: HeroProps = $props();

  let overlayVariant: 'dark' | 'light' | undefined;

  if (overlay) {
    overlayVariant = ['base', 'subdued', 'tonal'].some(v => colorVariant.includes(v)) ? 'light' :
                     ['contrast', 'vibrant'].some(v => colorVariant.includes(v)) ? 'dark' : undefined;
  }



  const classes = imageContentStyles.raw({ imagePosition, contentAlign, overlay: overlayVariant });
</script>

<Section
  {colorVariant}
  rootStyles={css.raw(classes.root, cssProp)}
  containerStyles={classes.container}
  {use}
>
  <div class={css(classes.content)}>
    {#if title}
      {#if headingType === 'h1'}
        <h1>{title}</h1>
      {/if}
      {#if headingType === 'h2'}
        <h2>{title}</h2>
      {/if}
      {#if headingType === 'h3'}
        <h3>{title}</h3>
      {/if}
      {#if headingType === 'h4'}
        <h4>{title}</h4>
      {/if}
      {#if headingType === 'h5'}
        <h5>{title}</h5>
      {/if}
      {#if headingType === 'h6'}
        <h6>{title}</h6>
      {/if}
    {/if}
    {#if description}
      <RichText blok={{ body: description }} />
    {/if}
    {@render children?.()}
  </div>

  {#if image && imagePosition !== 'none'}
    <Image
      src={image.src}
      alt={image.alt}
      width={1920}
      aspectRatio={16/9}
      css={classes.image}
    />
    <div class={css(classes.overlay)}></div>
  {/if}
</Section>
